import { instance } from "libs/api";

import { ApiRoutesMobileMoneyBalance } from "../../constants";
import { MobileMoneyBalanceResponse } from "./mobileMoneyBalance.types";

export const requestMobileMoneyBalance =
  async (): Promise<MobileMoneyBalanceResponse> => {
    return await instance.get(ApiRoutesMobileMoneyBalance.MobileMoneyBalance);
  };
